'use strict'

export default {
  init: function () {
    const plainPasswordEls = document.querySelectorAll<HTMLElement>('.display-plain-password')

    plainPasswordEls.forEach((plainPasswordEl) => {
      plainPasswordEl.addEventListener('click', function () {
        const inputId = this.getAttribute('data-input-id')

        if (inputId) {
          const inputEl = document.getElementById(inputId) as HTMLInputElement
          const inputType = inputEl.type

          let newType = 'text'
          if (inputType === 'text') {
            newType = 'password'
          }

          inputEl.type = newType
        }
      })
    })
  },
}
